// Function.ts
import { SetModalData, SetModalState } from "../interface/PopUp";

export function ReturnIndex(): void {    
    const rootElement = document.getElementById('root');
    if (rootElement) {
        rootElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

// O link do projeto (type register 2) é digitado à mão e não pode guardar
// espaço nenhum: ele vira url no servidor. Tira do começo, do meio e do fim.
//
// O \s do javascript já cobre o espaço comum, o tab, a quebra de linha e o
// espaço duro; o de largura zero (U+200B) entra à parte porque não conta como
// espaço para ele, e é um dos que vêm colados quando o link é copiado de uma
// página.
//
// O RemoveSpaces do PHP faz a mesma limpeza do outro lado: aqui é para o campo
// não ficar aceitando o que não vai ser gravado.
export function CleanProjectLink(link: string): string {
    return link.replace(/[\s​]+/g, '');
}

// Abre o link do projeto em outra aba.
//
// Link digitado sem "https://" abriria como caminho relativo do painel — o
// window.open só sai daqui quando o endereço tem esquema.
export function OpenProjectLink(link: string | null | undefined): void {
    const url = CleanProjectLink(String(link ?? ''));

    if(url === '') return;

    window.open(/^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : 'https://' + url, '_blank', 'noopener,noreferrer');
}

export function OpenFile(type: string, file: string): void {
    if(file !== ''){
        SetModalData('ShowFile', { "type": type, "file": file });
        SetModalState('ShowFile', true);
    }
}

export function AltStatus(origin: string, title: string, type: string, id: string | number, name: string, status: string | boolean): void {
    SetModalData('Confirmation', { "origin": origin, "title": title, "type": type, "id": id, "name": name, "status": status });
    SetModalState('Confirmation', true);
}

export function CallbackSuccess(title: string, text: string): void {
    SetModalData('ReturnResponse', { "page": "success", "title": title, "text": text });
    SetModalState('ReturnResponse', true);
}

export function CallbackError(title: string, text: string): void {
    SetModalData('ReturnResponse', { "page": "error", "title": title, "text": text });
    SetModalState('ReturnResponse', true);
}

export function CheckPassword(password: string, password2: string) {
    return {
        minLength: password.length >= 6,
        special:   /[^a-zA-Z0-9]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasUpper:  /[A-Z]/.test(password),
        match:     password !== '' && password === password2,
    };
}
